import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Web727 } from "web727token";

Web727.init({
    baseURL: process.env.REACT_APP_API_URL,
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <App />
);